import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useRef, useContext } from 'react';
export var TracingContext = /*#__PURE__*/createContext(undefined);
export var TracingProvider = function TracingProvider(props) {
  var breadCrumbs = useRef([]);
  var tracingService = useRef({
    getBreadcrumbs: function getBreadcrumbs() {
      return breadCrumbs.current;
    },
    recordBridgeCall: function recordBridgeCall(description) {
      return breadCrumbs.current = [].concat(_toConsumableArray(breadCrumbs.current), [{
        category: "forge.bridge",
        message: description,
        timestamp: new Date().toISOString()
      }]);
    },
    recordGqlCall: function recordGqlCall(description) {
      return breadCrumbs.current = [].concat(_toConsumableArray(breadCrumbs.current), [{
        type: 'http',
        category: 'gql',
        timestamp: new Date().toISOString(),
        data: {
          url: description
        }
      }]);
    },
    recordConsentFlow: function recordConsentFlow(description, result) {
      return breadCrumbs.current = [].concat(_toConsumableArray(breadCrumbs.current), [_objectSpread({
        category: "user.consent",
        message: description,
        timestamp: new Date().toISOString()
      }, result ? {
        data: {
          result: result
        }
      } : {})]);
    }
  });
  return /*#__PURE__*/React.createElement(TracingContext.Provider, {
    value: tracingService.current
  }, props.children);
};
export var useTracingContext = function useTracingContext() {
  var tracingContext = useContext(TracingContext);
  return tracingContext;
};